import tele from '@/assets/images/tele.svg';

export function Social() {
    return (
      <div className="flex items-center gap-2">
        <a
          href="https://x.com/HoldstationW"
          target="_blank"
          className="flex items-center justify-center h-8 px-2.5 rounded-full border border-[#24201C]"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width={20} height={18} viewBox="0 0 20 18" fill="none">
            <g filter="url(#filter0_d_19533_947)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.4608 1.8825C16.5329 1.8001 16.588 1.7043 16.6231 1.60059C16.6581 1.49689 16.6724 1.38729 16.6651 1.27807C16.6578 1.16884 16.629 1.06213 16.5804 0.964013C16.5319 0.865901 16.4645 0.778313 16.3821 0.70625C16.2997 0.634187 16.2039 0.579061 16.1002 0.544018C15.9965 0.508975 15.8869 0.494703 15.7776 0.502016C15.6684 0.509328 15.5617 0.538083 15.4636 0.586637C15.3655 0.635192 15.2779 0.702596 15.2058 0.785L10.9475 5.65167L7.33333 0.833333C7.25571 0.729837 7.15506 0.645834 7.03934 0.587977C6.92363 0.530121 6.79604 0.5 6.66667 0.5H3.33333C3.17857 0.5 3.02687 0.543096 2.89522 0.624458C2.76358 0.70582 2.65719 0.822234 2.58798 0.960655C2.51877 1.09908 2.48947 1.25404 2.50337 1.40817C2.51727 1.56231 2.57381 1.70953 2.66667 1.83333L8.03083 8.985L3.53917 14.1183C3.4671 14.2007 3.41198 14.2965 3.37693 14.4002C3.34189 14.5039 3.32762 14.6135 3.33493 14.7228C3.34225 14.832 3.371 14.9387 3.41955 15.0368C3.46811 15.1349 3.53551 15.2225 3.61792 15.2946C3.70032 15.3666 3.79611 15.4218 3.89982 15.4568C4.00353 15.4919 4.11313 15.5061 4.22235 15.4988C4.33158 15.4915 4.43829 15.4628 4.5364 15.4142C4.63452 15.3656 4.7221 15.2982 4.79417 15.2158L9.0525 10.3483L12.6667 15.1667C12.7443 15.2702 12.8449 15.3542 12.9607 15.412C13.0764 15.4699 13.204 15.5 13.3333 15.5H16.6667C16.8214 15.5 16.9731 15.4569 17.1048 15.3755C17.2364 15.2942 17.3428 15.1778 17.412 15.0393C17.4812 14.9009 17.5105 14.746 17.4966 14.5918C17.4827 14.4377 17.4262 14.2905 17.3333 14.1667L11.9692 7.015L16.4608 1.8825ZM13.75 13.8333L5 2.16667H6.25L15 13.8333H13.75Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_19533_947"
                x="-1.5"
                y="0.5"
                width={23}
                height="23.0007"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy={4} />
                <feGaussianBlur stdDeviation={2} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_19533_947" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_19533_947" result="shape" />
              </filter>
            </defs>
          </svg>
        </a>
  
        <a
          href="https://t.me/HoldstationW_EN/45773"
          target="_blank"
          className="flex items-center justify-center h-8 px-2.5 rounded-full border border-[#24201C]"
        >
          <img src={tele} alt="tele" width={18} height={15} loading="lazy" />
        </a>
      </div>
    );
  }
  